<template>
  <div
    @click.stop.prevent="toggle"
    :class="['favorite-button', { active }]"
  >
    <f-sprite-icon
      :icon-link="iconUrl"
    />
  </div>
</template>

<script>
import IconHeart from '@icons/heart.svg';
import IconHeartFill from '@icons/heart-fill.svg';
import { mapActions, mapGetters } from 'vuex';
import { commonGtmEvents } from '@/gtm/common-gtm-events';

export default {
  name: 'favorite-button',

  props: {
    productId: {
      type: String,
      required: true,
    },

    productCode: {
      type: String,
      required: true,
    },

    skuId: {
      type: String,
      default: '',
    },
    productPrice: {
      type: String,
      default: '',
    },
    quantity: {
      type: [String, Number],
      default: 1,
    }
  },

  computed: {
    ...mapGetters({
      favoritesShort: 'favorites/short',
      FAVORITES_SHORT_COUNT: 'favorites/favoritesShortCount',
    }),

    active() {
      return this.productId in this.favoritesShort;
    },

    iconUrl() {
      return this.active
        ? IconHeartFill.id
        : IconHeart.id
      ;
    },
  },

  methods: {
    ...mapActions({
      toggleFavorite: 'favorites/toggle',
      CREATE_NOTIFICATION: 'notifications/create',
    }),

    toggle() {
      this.$f.login().then(() => {
        if (!this.active && this.FAVORITES_SHORT_COUNT >= 100) {
          return this.CREATE_NOTIFICATION({
            title: 'Внимание!',
            message: 'Невозможно добавить более 100 товаров в избранное',
            type: 'warning',
          });
        }

        this.toggleFavorite({
          productId: this.productId,
          skuId: this.skuId,
        });
        // Google Tag Manager event
        commonGtmEvents.toggleFavorite({
          value: this.active,
          productCode: this.productCode,
          productId: this.productId,
          price: this.productPrice,
          quantity: this.quantity,
        });

        this.$emit('change', this.active);
      }).catch(() => {});
    },
  },
}
</script>

<style lang="scss">
.favorite-button {
  width: 24px;
  height: 24px;
  &.active {
    color: $red !important;
  }
  &:not(.active) {
    color: $gray;
    &:hover {
      color: $black;
    }
  }
}
</style>
